import React from 'react';
import Data from './Data';

const TeaserTabSidebar = (props) => {
  return <Data {...props} />;
};

export default TeaserTabSidebar;
